import { MdRouter } from "react-icons/md";
import "./App.css";
import About from "./components/About";
import Contact from "./components/Contact";
import Experience from "./components/Experience";
import Footer from "./components/Footer";
import Header from "./components/Header";
import Home from "./components/Home";
import Projects from "./components/Projects";
import Skills from "./components/Skills";

function App() {
  return (
    <>
      <Header/> 
      <Home/>
      <About />
      <Skills/>
      <Projects/>
      <Experience />
      <Contact />
      <Footer/>
    </>
  );
}

export default App;

